module.exports = __webpack_public_path__ + "img/icon-mail-white.45d1ab5e.svg";